module.exports = __webpack_public_path__ + "static/media/CermonyLamerd.612d5a6f.jpg";